import HandleError from "../../scripts/ErrorHandler";
import getInspections from "../../api/GetInspections";
import {ActionTypes} from "./ActionTypes";
import {setSideBarData} from "./SideBar";
import {getSideBarForInspection, initialSideBar} from "../../types/SideBarData";
import { toast } from "react-toastify";
import getInspection from "../../api/GetInspection";
import {DocumentReuseStatus, getCheckListCount, Inspection} from "../../types/Inspection";
import {Action, ActionCreator, Dispatch} from "redux";
import {PortalState} from "../../types/PortalState";
import {AssetState} from "../../types/AssetState";
import {AssetType} from "../../types/AssetType";
import {CheckList} from "../../types/CheckList";
import SurveyorCompletionStatus, {defaultSurveyorCompletionStatus} from "../../types/SurveyorCompletionStatus";
import {Auth} from "aws-amplify";
import {ImageDeleteData} from "../../types/ImageDeleteData";
import getInspectionCarbonData from "../../api/GetInspectionCarbonData";
import {initialCarbonSectionData} from "../../types/CarbonSectionData";
import {CarbonSectionData} from "../../types/CarbonSection";
import {setUserType} from "./Auth";
import {LoggedInUserType} from "../../types/LoggedInUserType";
import {updateInspectionDocumentReuseStatus, updateInspectionReportReuseStatus, assignImagesToDefect} from "../../api/InspectionReuse";
import InspectionElement from "../../types/InspectionElement";
import {DefectItem} from "../../types/DefectItem";
import {DefectImage} from "../../types/DefectImage";
import {dateStringToEpoch, isPastDate} from "../../helpers/dates";
import Asset from "../../types/Asset";
import addMetadata from "../../api/AddMetadata";
import {getAllAssets, getNonValidReUseAssets, getReUseAssets, getValidReUseAssets} from "../../types/ReUseAsset";
import ReactGA from "react-ga4";

const storeInspectionsInStore: ActionCreator<Action> = (
    inspections: Inspection[]
) => {
    return {
        type: ActionTypes.GET_INSPECTIONS,
        inspections: inspections
    };
};

export const getInspectionAction = () => {
    return async (dispatch: Dispatch<Action>, getState: () => PortalState) => {
        try {
            const currentSession = await Auth.currentSession();
            const idToken = currentSession.getIdToken().getJwtToken();

            const inspections = getState().portal.inspections;

            if (inspections) {
                dispatch(storeInspectionsInStore(inspections));
                return;
            }

            getInspections(idToken).then(async (response: any) => {
                const inspections = response.data;

                for (let i = 0; i !== inspections.length; i++) {
                    const inspectionDetails: any =
                        await requestInspectionFromApi(
                            inspections[i].Id,
                            idToken,
                            dispatch
                        );
                    inspections[i].NumberOfDocuments =
                        inspectionDetails.NumberOfDocuments;
                    inspections[i].NumberOfPhotos =
                        inspectionDetails.NumberOfPhotos;
                    inspections[i].NumberOfChecklists =
                        getCheckListCount(inspectionDetails);
                }

                dispatch(storeInspectionsInStore(inspections));
            });
        } catch (e: any) {
            HandleError(e);
        }
    };
};

export const saveInspectionResult: ActionCreator<Action> = (
    inspection: Inspection
) => {
    return {
        type: ActionTypes.GET_INSPECTION_BY_NUMBER,
        activeInspection: inspection
    };
};

export const updateCheckList: ActionCreator<Action> = (
    checkLists: CheckList[]
) => {
    return {
        type: ActionTypes.UPDATE_CHECKLIST,
        checkLists: checkLists
    };
};

export const setImageDeleteMode: ActionCreator<Action> = (
    imageDeleteMode: boolean
) => {
    return {
        type: ActionTypes.SET_IMAGE_DELETE_MODE,
        imageDeleteMode
    };
};

export const addImageToDeleteList: ActionCreator<Action> = (
    imageData: ImageDeleteData
) => {
    return {
        type: ActionTypes.ADD_IMAGE_TO_DELETE_LIST,
        imageData
    };
};

export const removeImageFromDeleteList: ActionCreator<Action> = (
    imageData: ImageDeleteData
) => {
    return {
        type: ActionTypes.REMOVE_IMAGE_FROM_DELETE_LIST,
        imageData
    };
};

function handleUserTypeUpdate(isDocumentCollector: boolean, dispatch: Dispatch<Action>) {
    if (isDocumentCollector) {
        dispatch(setUserType(LoggedInUserType.DOCUMENT_COLLECTOR));
    }
}

const requestInspectionFromApi = (
    inspectionNumber: string,
    idToken: string,
    dispatch: Dispatch<Action>
) => {
    return new Promise(function (resolve, reject) {
        dispatch(setSideBarData(initialSideBar));


        getInspection(inspectionNumber, idToken)
            .then((response: any) => {
                const inspection = response.data;
                const checkLists: CheckList[] = [];
                dispatch(setSideBarData(getSideBarForInspection(inspection)));

                handleUserTypeUpdate(inspection.isDocumentCollector, dispatch);
                for (let i = 0; i !== inspection.sections.length; i++) {
                    if (
                        inspection.sections[i].ElementType ===
                        AssetType.CheckList
                    ) {
                        checkLists.push(inspection.sections[i].checkList);
                    }

                    for (
                        let j = 0;
                        j !== inspection.sections[i].Documents.length;
                        j++
                    ) {
                        inspection.sections[i].Documents[j].state =
                            AssetState.DISPLAYING;
                        inspection.sections[i].Documents[j].progress = 100;
                        inspection.sections[i].Documents[j].type =
                            AssetType.Document;
                    }

                    for (
                        let k = 0;
                        k !== inspection.sections[i].Images.length;
                        k++
                    ) {
                        inspection.sections[i].Images[k].state =
                            AssetState.DISPLAYING;
                        inspection.sections[i].Images[k].progress = 100;
                        inspection.sections[i].Images[k].type = AssetType.Image;
                    }
                }

                getInspectionCarbonData(inspectionNumber, idToken)
                    .then((response: any) => {
                        let carbonData = response.data;

                        inspection.SurveyorCompletionStatus = validateSurveyorCompletionStatus(inspectionNumber, inspection.SurveyorCompletionStatus);

                        carbonData = validateCarbonData(carbonData);
                        inspection.CarbonSectionData = carbonData;

                        dispatch(updateCheckList(checkLists));
                        dispatch(saveInspectionResult(inspection));
                        resolve(inspection);
                    })
                    .catch(() => {
                        const carbonData = validateCarbonData({} as CarbonSectionData);
                        inspection.CarbonSectionData = carbonData;

                        dispatch(updateCheckList(checkLists));
                        dispatch(saveInspectionResult(inspection));
                        resolve(inspection);
                    });
            })
            .catch((e) => {
                HandleError(e);
                reject(e);
            });
    });
};

export const getInspectionById = (inspectionNumber: string) => {
    return async (dispatch: Dispatch<Action>, getState: () => PortalState) => {
        const currentSession = await Auth.currentSession();
        const idToken = currentSession.getIdToken().getJwtToken();

        const inspection =
            getState().portal.inspectionDetails.get(inspectionNumber);

        if (!inspection) {
            return requestInspectionFromApi(
                inspectionNumber,
                idToken,
                dispatch
            );
        }

        dispatch(setSideBarData(getSideBarForInspection(inspection)));
        dispatch(saveInspectionResult(inspection));
    };
};

const doNotReUseAssets = async (inspectionId : string ,
                                updatedReuseElements: InspectionElement[],
                                activeInspection : Inspection) => {

    const currentSession = await Auth.currentSession();
    const idToken = currentSession.getIdToken().getJwtToken();

    //    Always set the inspection elements for reuse -- the system is never not in a reuse mode...
    const updateReportPromises = updatedReuseElements.map((element) => {
        return updateInspectionReportReuseStatus(inspectionId, element.Id, true, idToken);
    });

    ReactGA.event({
        category: "DOCUMENT_REUSE",
        action: "REUSE_SKIPPED",
        label: `${inspectionId}`,
        value: 0
    });

    await Promise.all(updateReportPromises);

    // THIS IS ALWAYS SET TO RE-USE -- THE UI IN THE PORTAL NO-REUSE MEAN TO REUSE BUT MARK ALL EXISTING
    // COMPONENTS ARE NOT RE USABLE
    await updateInspectionDocumentReuseStatus(inspectionId, DocumentReuseStatus.RE_USE, idToken,[]);

    // Now Set the meta-data to expire on all assets -- regardless of flag...
    const nonReUseAssets = getAllAssets(activeInspection,updatedReuseElements);
    const updateMetadataPromises = nonReUseAssets.map((asset) => {
        return addMetadata(
            asset.asset_id as string,
            "reusable",
            "false",
            idToken
        )
    });
    await Promise.all(updateMetadataPromises);

    activeInspection.NumberOfDocuments = 0;
}


export const updateInspectionReuseStatus = (inspectionId: string,
                                            reuseStatus: DocumentReuseStatus,
                                            updatedReuseElements: InspectionElement[],
                                            activeInspection : Inspection) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionTypes.UPDATE_INSPECTION_REUSE_STATUS_SAVING
        });

        try {

            if(reuseStatus == DocumentReuseStatus.NOT_RE_USE){
                // The system is always in a reuse state
                // This functionality is setting existing re-use assets to be not reusable anymore...
                await doNotReUseAssets(inspectionId,updatedReuseElements,activeInspection);
                dispatch(setSideBarData(getSideBarForInspection(activeInspection)));

                dispatch({
                    type: ActionTypes.UPDATE_INSPECTION_REUSE_STATUS_SUCCESS,
                    inspectionReuseStatus: DocumentReuseStatus.NOT_RE_USE
                });
            }
            else {
                const currentSession = await Auth.currentSession();
                const idToken = currentSession.getIdToken().getJwtToken();
                const updateReportPromises = updatedReuseElements.filter(e => e.ReUseDocuments).map((element) => {
                    return updateInspectionReportReuseStatus(inspectionId, element.Id, element.ValidForReuse, idToken);
                });

                await Promise.all(updateReportPromises);

                const reUseAssets = getReUseAssets(
                    activeInspection, updatedReuseElements, false);
                await updateInspectionDocumentReuseStatus(inspectionId, reuseStatus, idToken,reUseAssets);

                dispatch({
                    type: ActionTypes.UPDATE_INSPECTION_REUSE_STATUS_SUCCESS,
                    inspectionReuseStatus: reuseStatus
                });
            }

        } catch (e: any) {
            dispatch({
                type: ActionTypes.UPDATE_INSPECTION_REUSE_STATUS_FAILED,
                errorMessage: e
            });
        }
    }
}

export const updateInspectionReportReuse = (inspectionId: string, updatedReuseElements: InspectionElement[], activeInspection: Inspection) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionTypes.UPDATE_INSPECTION_REPORT_REUSE_SAVING
        });

        try {
            const currentSession = await Auth.currentSession();
            const idToken = currentSession.getIdToken().getJwtToken();

            // Split the assets into 2 buckets of data based on the flags set in the client..
            const validReUseAssets = getValidReUseAssets(activeInspection,updatedReuseElements);
            const inValidReUseAssets = getNonValidReUseAssets(activeInspection,updatedReuseElements);

            validReUseAssets.forEach((asset) => {
                ReactGA.event({
                    category: "DOCUMENT_REUSE",
                    action: "ELEMENT_REUSE_APPROVED",
                    label: `Survey Element - ${asset.survey_element_id}. Inspection Report Id - ${asset.inspection_report_id}`,
                    value: 0
                });
            });

            // Always set the inspection elements for reuse -- the system is never not in a reuse mode...
            const updateReportPromises = updatedReuseElements.map((element) => {
                return updateInspectionReportReuseStatus(inspectionId, element.Id, true, idToken);
            });

            await Promise.all(updateReportPromises);

            await updateInspectionDocumentReuseStatus(inspectionId, DocumentReuseStatus.RE_USE, idToken,validReUseAssets);

            dispatch({
                type: ActionTypes.UPDATE_INSPECTION_REPORT_REUSE_SUCCESS,
                inspectionReuseStatus: DocumentReuseStatus.RE_USE,
                updatedReuseElements: updatedReuseElements
            });

            // Now Set the meta-data to expire on invalid assets...
            const updateMetadataPromises = inValidReUseAssets.map((asset) => {
                return addMetadata(
                    asset.asset_id as string,
                    "reusable",
                    "false",
                    idToken
                )
            });
            await Promise.all(updateMetadataPromises);

            activeInspection.NumberOfDocuments = activeInspection.sections.reduce((acc, cur) => acc + cur.Documents.length, 0);
            dispatch(setSideBarData(getSideBarForInspection(activeInspection)));

        } catch (e: any) {
            dispatch({
                type: ActionTypes.UPDATE_INSPECTION_REPORT_REUSE_FAILED,
                errorMessage: e
            });
        }
    }
}

export const updateGlobalExpiryDate = (
    newDate: string) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionTypes.UPDATE_GLOBAL_EXPIRY_DATE,
            globalExpiryDate: newDate
        });
    }
}



export const updateDocumentExpiryDate = (
    newDate: string,
    sectionId: any,
    assets: Array<Asset>,
) => {

    return async (dispatch: Dispatch<Action>) => {
        if (isPastDate(newDate)) {
            dispatch({
                type: ActionTypes.SET_EXPIRY_DATE_ERROR,
                section: sectionId,
                errorMessage: "Invalid date"
            });
            return;
        }

        dispatch({
            type: ActionTypes.SET_SAVING_EXPIRY_DATE,
            section: sectionId,
            newDate: newDate
        });

        try {
            const currentSession = await Auth.currentSession();
            const idToken = currentSession.getIdToken().getJwtToken();
            const epochDate = dateStringToEpoch(newDate);

            const updateMetadataPromises = assets.map((asset) => {
                return addMetadata(
                    asset.id as string,
                    "reusable-expiry",
                    epochDate.toString(),
                    idToken
                )
            });

            await Promise.all(updateMetadataPromises);

            dispatch({
                type: ActionTypes.SAVING_EXPIRY_DATE_SUCCESS,
                section: sectionId,
                newExpiryDate: epochDate
            });
        } catch(e) {
            dispatch({
                type: ActionTypes.SAVING_EXPIRY_DATE_ERROR,
                section: sectionId,
                errorMessage: e
            });
        }
    }
}

/**
 * Handle response from API. Blank objects should be given default data
 * @param carbonData 
 * @returns 
 */
function validateCarbonData(carbonData: CarbonSectionData): CarbonSectionData {
    // Set default states if no data
    if (Object.keys(carbonData).length === 0) {
        carbonData = initialCarbonSectionData;
    } else {
        if (carbonData.AeroplaneSection === undefined) {
            carbonData.AeroplaneSection = initialCarbonSectionData.AeroplaneSection;
        }
        if (carbonData.CarSection === undefined) {
            carbonData.CarSection = initialCarbonSectionData.CarSection;
        }
        if (carbonData.TrainSection === undefined) {
            carbonData.TrainSection = initialCarbonSectionData.TrainSection;
        }
    }
    // Return the API object
    return carbonData;
}

function validateSurveyorCompletionStatus(inspectionId: string, surveyorCompletionStatus: SurveyorCompletionStatus) {
    if (surveyorCompletionStatus === null) {
        surveyorCompletionStatus = defaultSurveyorCompletionStatus(inspectionId);
    }

    if (surveyorCompletionStatus.EmbarkDate) {
        surveyorCompletionStatus.EmbarkDate = new Date(surveyorCompletionStatus.EmbarkDate).toISOString().slice(0, 16);
    }

    if (surveyorCompletionStatus.DisembarkDate) {
        surveyorCompletionStatus.DisembarkDate = new Date(surveyorCompletionStatus.DisembarkDate).toISOString().slice(0, 16);
    }
    return surveyorCompletionStatus;
}

export const updateDefectImageAssignment = (
    inspectionId: string,
    defect: DefectItem,
    selectedImages: DefectImage[],
    defectElementId: string
) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionTypes.ASSIGN_IMAGES_TO_DEFECT_SAVING
        });

        try {
            const currentSession = await Auth.currentSession();
            const idToken = currentSession.getIdToken().getJwtToken();

            await assignImagesToDefect(inspectionId, defect, selectedImages, defectElementId, idToken);

            dispatch({
                type: ActionTypes.ASSIGN_IMAGES_TO_DEFECT_SUCCESS,
                defect: defect,
                selectedImages: selectedImages
            });

            toast.success("Images successfully assigned to defect");

        } catch (e: any) {
            dispatch({
                type: ActionTypes.ASSIGN_IMAGES_TO_DEFECT_FAILED,
                errorMessage: e
            });

            toast.error("Failed to assign images to defect. Please try again.");
        }
    }
}